export default __webpack_public_path__ + "static/media/fort.834280c3.svg";